<template>
  {{ label }}
</template>

<script setup lang='ts' generic="OPTION">
import {
  computed,
} from 'vue';

import {
  TOption,
  isNamedOption,
} from './qmulus-dropdown';

const props = defineProps<{
  option: TOption<OPTION>,
}>();

const label = computed(() => isNamedOption(props.option) ? props.option.displayName : props.option);
</script>
